import selectableUserRowUrl from './selectable-user-row.html';

export default {
  controllerAs: 'ctrl',
  bindings: {
    user: '<',
    onSelect: '&',
  },
  templateUrl: selectableUserRowUrl,
};
